export interface ChartKeyItem {
  label: string;
  color: string;
  /** A line series gets a short stroke; anything else a small square. */
  kind?: 'line' | 'box';
  opacity?: number;
}

/**
 * The small legend that sits under every Finance chart, so a reader finds it in
 * the same place on each card instead of above one chart and below the next.
 */
export function ChartKey({ items }: { items: ChartKeyItem[] }) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-body-xs text-text-tertiary">
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <span
            aria-hidden
            className={item.kind === 'line' ? 'h-0.5 w-4 rounded' : 'h-2.5 w-2.5 rounded-sm'}
            style={{ backgroundColor: item.color, opacity: item.opacity ?? 1 }}
          />
          {item.label}
        </span>
      ))}
    </div>
  );
}
